import { WorkflowStepsBaseService } from "app/core/workflow/workflow-steps/workflow-steps-base.service";
import { AdditionalOptionsSpouseComponentPath } from "app/core/workflow/page-path/statement-page-path/additional-options-spouse-component.path";

export class WorkflowAdditionalOptionsSpouseService extends WorkflowStepsBaseService {
  public get isRequired(): boolean {
    return !this.isBusiness && this.hasSpouseAndFilledTogether;
  }

  public get isVisible(): boolean {
    return this.isRequired;
  }

  public get isFakeStep(): boolean {
    return false;
  }

  public get title(): string {
    return "ASIDE_BAR.STEUER_INCOME_DEDUCTION";
  }

  public get isDone(): boolean {
    return !!this.statement && !!this.statement.spouse && !!this.statement.spouse.stageSteuerAdditionalOption;
  }

  public get checkCanGo(): boolean {
    return !this.blockedDefaultWorkflow && this.isVisible && this.isSpouseStageEmployerDone;
  }

  public get isActiveOnStepsBar(): boolean {
    return window.location.href.search(AdditionalOptionsSpouseComponentPath.regex()) !== -1;
  }

  public get isActive(): boolean {
    return this.defaultIsActiveFunction;
  }

  public get stepClass(): string {
    return this.classHasSubs;
  }

  public get urlRegex(): RegExp {
    return AdditionalOptionsSpouseComponentPath.regex(1);
  }

  public get url(): string {
    return AdditionalOptionsSpouseComponentPath.url(this.getStatementId, this.getSpouseId, 1);
  }
}
